define('components/decorators/order-extracts',[
    'jquery',
    '../util/reload-fragments',
    'components/decorator'
],function($, reload, decorator){
    $.extend(companyInfo.decorators, {
        'order-extracts': function() {
            var pendingOrderId = $("[data-pending-order-id]").data("pendingOrderId");
            var isPageLoadedFromUserFormSubmission = $("[data-user-submitted-form]").length > 0;
            var downloadBtn = $('input[type=submit]');
            var pendingOrderEl = $('[data-pending-order-element]');
            // Preventing form submission if user refreshes the page while POST is still active
            history.replaceState(null, document.title, location.href);

            // Start polling if there are pending extract orders
            if (pendingOrderId !== undefined && isPageLoadedFromUserFormSubmission) {
                pollForStatus(pendingOrderId);
            }

            downloadBtn.on('click', function(e) {
                if (pendingOrderId !== undefined && !isPageLoadedFromUserFormSubmission) { // If backend ordered in the background before page load
                    e.preventDefault();

                    if (pendingOrderEl.data('pendingOrderElement')) {
                        pendingOrderEl.removeClass('hidden'); // Show previously hidden pending item
                    }
                    $('.order-panel-loader').css('display', 'flex'); // Show loader
                    $('[data-no-docs-message]').addClass('hidden'); // Hide no documents message (in case we showed it because there was only one pending order that we hidden) if it exists
                    pollForStatus(pendingOrderId);
                }
            });

            function pollForStatus(orderId) {
                (function poll() {
                    var infoBoxEl = $('.order-info');
                    var errorBoxEl = infoBoxEl.find('.error-box');
                    $.ajax({
                        url: "/orders/" + orderId,
                        type: "GET",
                        success: function(data) {
                            var status = data.status;
                            var errorCode = data.error;
                            if (status === "pending") {
                                // If order is pending, repeat after 3 seconds
                                setTimeout(poll, 3000);
                            } else {
                                if (status === 'finished') {
                                    // Show success message
                                    var successBoxEl = infoBoxEl.find('.success-box');
                                    successBoxEl.removeAttr('style');
                                } else if (status === 'failed' && errorCode) {
                                    // Show error message for given error code
                                    var textEl = errorBoxEl.find('#' + errorCode);
                                    textEl.removeClass('hidden');
                                    errorBoxEl.removeAttr('style');
                                } else if (status === 'failed' && !errorCode) {
                                    // Show generic error message
                                    var genericErrorTextEl = errorBoxEl.find('#generic');
                                    genericErrorTextEl.removeClass('hidden');
                                    errorBoxEl.removeAttr('style');
                                }
                                infoBoxEl.removeAttr('data-decorated');
                                decorator.run(infoBoxEl.parent()); // Run info-box decorator so that info-box fades away

                                $('.order-panel-loader').remove();
                                pendingOrderId = undefined;
                                reloadHistoricalExtractsList();
                            }

                        },
                        error: function() {
                            setTimeout(poll, 3000);
                        },
                        dataType: "json"
                    });
                })();
            }

            function reloadHistoricalExtractsList() {
                // Reload historical extracts list
                reload("extracts");
            }
        }
    });
});

